module.exports = __webpack_public_path__ + "img/CRM.0496f630.png";